import { useTranslation } from "@opendash/i18n";
import { Select, SelectProps, Tag } from "antd";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { AllSaveViews } from "../../types/Config";

type Props = {
  onChange?: SelectProps["onChange"];
  value?: SelectProps["value"];
};

export const TypeSelect = observer((props: Props) => {
  const t = useTranslation();

  const options = useMemo(
    () =>
      AllSaveViews.map((view) => ({
        label: t(
          "maintenance:ticket.creation.config.form.view.type.label." + view
        ),
        value: view,
      })),
    []
  );

  if (props.onChange)
    return (
      <Select options={options} {...props} defaultValue={AllSaveViews[0]} />
    );

  return (
    <Tag>
      {t(
        "maintenance:ticket.creation.config.form.view.type.label." + props.value
      )}
    </Tag>
  );
});
